import React from 'react';
import useSaveAssignment from '../useSaveAssignment';
/**
 * Component to display a treatment
 * @param {String} when
 * @param {Object} treatments
 * @param {Boolean} control
 * @param {Function|Object} children
 * @returns {*}
 */
var Treatment = function Treatment(_ref) {
  var when = _ref.when,
    treatments = _ref.treatments,
    _ref$control = _ref.control,
    control = _ref$control === void 0 ? false : _ref$control,
    children = _ref.children;
  var saveAssignment = useSaveAssignment();
  var childElement = typeof children === 'function' ? children() : children;
  var allTreatments = Object.keys(treatments);

  // see if the user has been assigned to _any_ treatment. this will be needed if we need to fall back to the control state
  var hasAssignment = allTreatments.findIndex(function (treatmentName) {
    return treatments[treatmentName].treatmentName;
  }) > -1;

  // If experiments fails, or the user hasn't been assigned and experiment show the control.
  if ((allTreatments.length === 0 || !hasAssignment) && control) {
    return childElement;
  }

  // if our treatment exists in the object
  if (allTreatments.length) {
    if (treatments[when] && treatments[when].treatmentName) {
      saveAssignment(treatments[when]);

      // Let's return the child element without waiting for the mutation as the
      // mutation doesn't really impact the children.
      return childElement;
    }
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default Treatment;
//# sourceMappingURL=index.js.map